import * as React from "react";
import L from "leaflet";
import {Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button} from 'react-bootstrap';
import {DisplayFeature} from "../../domain";

interface CutConfirmModalProps {
    feature: DisplayFeature,
    position: L.LatLng,
    confirmCut(feature: DisplayFeature, position: L.LatLng): void,
    cancelCut(): void
}

export default class CutConfirmModal extends React.Component<CutConfirmModalProps, {}> {

    constructor(props: CutConfirmModalProps, context: any) {
        super(props, context);
    }

    render() {
        return <Modal show={true} onHide={this.props.cancelCut}>
            <ModalHeader>
                <ModalTitle>Bekreft klipping av vegobjekt</ModalTitle>
            </ModalHeader>
            <ModalBody>

                <p>Vennligst bekreft at du ønsker å klippe vegobjektet {this.props.feature.name}.</p>
                <p>Stedfesting og assosiasjoner vil bli fjernet fra dette vegobjektet.</p>
            </ModalBody>
            <ModalFooter>
                <Button bsStyle="default" onClick={this.props.cancelCut}>Avbryt</Button>
                <Button bsStyle="primary" onClick={()=> {
                    this.props.confirmCut(this.props.feature, this.props.position)
                }}>Klipp</Button>
            </ModalFooter>
        </Modal>;
    }
}
